function ajaxHandlersInit(){

    $(document).on('submit.valid', '.form-ajax form', function () {
        var form =  $(this);

        var data = form.serialize();
            $.ajax({
                type: "POST",
                url: "/mail.php",
                data: data+"&web_form_submit=Y&submit=Y",
                success: function(data) {

                    $.fancybox.close();
                    $.fancybox.open(data);

                    $("#form-con").html('<p class="form--item-label" style="font-size: 18px; margin-top: 40px">Спасибо, ваша заявка отправлена на обработку. Пожалуйста, не отправляйте повторные запросы.</p>');

                },
                error: function(data) {
                    $(form).find('.js-form-submit').text('Произошла ошибка');
                    setTimeout(function() {
                        $(form).find('.js-form-submit').text('Отправить');
                    }, 2000);
                }
            });
        return false;
    });

    $(document).on("click",".send-sms-handler",function () {
        $(this).closest(".form--item").hide();
        $(".send-sms-block").show();

        var data = {
            "id": $(this).data("id")
        };

        $.ajax({
            type: "POST",
            url: "/ajax/sendsms.php",
            data: data,
            dataType: "json",
            success: function(res) {
                $(".send-sms-block [name='session_id']").val(res.SESSION);

            }
        });


        return false;
    });

    $(document).on('submit.valid', '.form-sms form', function () {
        var form =  $(this);

        var data = form.serialize();
        $.ajax({
            type: "POST",
            url: "/ajax/checksmscode.php",
            data: data,
            success: function(data) {
                $.fancybox.close();
                $.fancybox.open(data);
            }
        });
        return false;
    });


}
    